import { Play } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

interface EditorMobileNavProps {
  onPlay: () => void;
  settingsTrigger: React.ReactNode;
}

export function EditorMobileNav({
  onPlay,
  settingsTrigger,
}: EditorMobileNavProps) {
  const { t } = useTranslation();

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background border-t-2 border-black p-3 pb-safe">
      <div className="flex items-center gap-3">
        {/* Settings Button Wrapper */}
        <div className="flex-1">
          {settingsTrigger}
        </div>

        {/* Start Teleprompter Button */}
        <Button
          onClick={onPlay}
          className="
            flex-1 h-12 text-base font-bold
            bg-[#FF6B9D] text-black border-2 border-black rounded-lg
            hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-[4px_4px_0_#1A1A1A]
            active:translate-x-1 active:translate-y-1 active:shadow-none
            transition-all duration-100
          "
        >
          <Play className="h-5 w-5 mr-2 fill-current" />
          {t("editor.startTeleprompter")}
        </Button>
      </div>
    </div>
  );
}
